<template>
    <div>
        <mq-layout mq="wide">
            <header class="logged-in">

                <div class="header-logo">
                    <a :href="companyLogoUrl" target="_blank">
                        <img :src="getHkepLogo()">
                    </a>
                    <a href="/">
                        <img :src="logo">
                    </a>
                </div>
                <div v-show="showRightMenu">
                    <div class="right-menu"  v-show="!is404">
                        <a :href="relation_url"
                           class="btn-language"
                           v-show="this.storeMainSite.relation !== null"
                        >
                            {{ relation_lang }}
                        </a>

                        <template v-if="showLoginBtn">
                            <div class="user-btn" :tooltip="lang($t('Menu'))" flow="down">

                                <img class="profile-pic" @click='showMember' :src='member_avatar' />

                                <!--header dropdwon menu-->
                                <div class="header-dropdown-menu" v-show='showMemberTool'>
                                    <a href="javascript:void(0)" @click="logout">
                                        <p>{{ lang($t("Logout")) }}</p>
                                        <span>{{ display_name }}</span>
                                    </a>
                                </div>
                                <!--end header dropdown menu-->

                            </div>
                        </template>
                        <template v-else>
                            <a class="btn-login" href="javascript:void(0)" @click="showLogin">{{ lang($t('Login')) }}</a>
                        </template>


                        <div class="setting-menu-btn" :tooltip="lang($t('Settings'))" flow="down">
                            <div @click='showSetting'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                                    <path d="M40,24 C31.177808,24 24,31.1773452 24,40 C24,48.8226548 31.1773452,56 40,56 C48.8226548,56 56,48.8226548 56,40 C56,31.1773452 48.822192,24 40,24 Z M40,50 C34.4861479,50 30,45.5138521 30,40 C30,34.4861479 34.4861479,30 40,30 C45.5138521,30 50,34.4861479 50,40 C50,45.5138521 45.5138521,50 40,50 Z M79.4976709,33.9328069 C79.3080463,32.68311 78.4462415,31.6404716 77.2566112,31.2185497 L70.9540038,28.9776347 C70.5811826,27.9216821 70.1583152,26.8951126 69.6895338,25.902058 L72.557778,19.8666004 C73.0991034,18.7284672 72.9705443,17.3823572 72.2230653,16.3645107 C69.8056961,13.0768253 66.9172497,10.1885655 63.6380757,7.78237096 C62.6192453,7.03448107 61.2776398,6.90730765 60.1371374,7.44997546 L54.1049632,10.3157389 C53.1118445,9.8469878 52.0838313,9.42506588 51.0268922,9.05226871 L48.7849143,2.74915006 C48.3629651,1.56189208 47.3230142,0.702438508 46.0759915,0.510530606 C41.6452957,-0.17032925 38.3661217,-0.17032925 33.9285388,0.510530606 C32.6828935,0.702438508 31.6415652,1.56189208 31.219616,2.74915006 L28.977638,9.05226871 C27.920699,9.42506588 26.8926858,9.8469878 25.9004854,10.3157389 L19.8660155,7.44997546 C18.7278088,6.90776676 17.3839076,7.03494018 16.3659954,7.78237096 C13.0868214,10.1885655 10.1983751,13.0768253 7.78100583,16.3645107 C7.03306765,17.3823572 6.90496775,18.7280081 7.44629317,19.8666004 L10.3145374,25.902058 C9.84575597,26.8932761 9.42380681,27.9221412 9.05006729,28.9776347 L2.74654168,31.2208452 C1.55782962,31.6427671 0.697402275,32.6849464 0.506400261,33.9328069 C0.162504807,36.1916272 0.00180599647,38.1175929 0.00180599647,40.0017795 C0.00180599647,41.8832116 0.162504807,43.8119319 0.506400261,46.0707522 C0.696024857,47.3204491 1.55782962,48.3630875 2.74745995,48.7850094 L9.05006729,51.0259244 C9.42380681,52.0837134 9.84713339,53.1107421 10.3145374,54.1037966 L7.44629317,60.1369587 C6.90496775,61.2750919 7.03352679,62.6212019 7.78008755,63.6367528 C10.1942428,66.9221426 13.0826892,69.8104025 16.3659954,72.2211881 C17.3839076,72.969078 18.7278088,73.098547 19.8669338,72.5535836 L25.899108,69.6878202 C26.8922266,70.1565713 27.9202399,70.5784932 28.9771789,70.9512904 L31.2191569,77.254409 C31.641106,78.441667 32.6810569,79.3011206 33.9280797,79.4930285 C36.144805,79.8346062 38.1310423,79.9998857 40.0015764,79.9998857 C41.8721106,79.9998857 43.858807,79.8346062 46.0750732,79.4930285 C47.3216368,79.3011206 48.3620468,78.441667 48.783996,77.254409 L51.0259739,70.9512904 C52.082913,70.5784932 53.1109262,70.1565713 54.1040449,69.6878202 L60.1362191,72.5535836 C61.2767215,73.0980879 62.6206227,72.9686189 63.6385349,72.2211881 C66.9255142,69.8062705 69.8139606,66.9180107 72.2235244,63.6367528 C72.9700852,62.6212019 73.0986442,61.2750919 72.5573188,60.1369587 L69.6890746,54.1037966 C70.157856,53.1107421 70.5807235,52.0814179 70.9535447,51.0259244 L77.256152,48.7850094 C78.4457824,48.3630875 79.3075871,47.3209082 79.4972117,46.0707522 C79.8411072,43.8119319 80.001806,41.8836707 80.001806,40.0017795 C80.001806,38.1198884 79.8415663,36.1911681 79.4976709,33.9328069 Z M73.8322417,43.1055573 L67.7665494,45.2628706 C66.7063014,45.6382808 65.8909796,46.499322 65.5716335,47.5803338 C65.0299697,49.4121661 64.3168576,51.1455532 63.4501956,52.7348054 C62.9122999,53.7239666 62.878858,54.9104889 63.3621163,55.9269697 L66.1132973,61.7135624 C64.7841015,63.30988 63.3140731,64.782317 61.7154584,66.1101481 L55.9300182,63.3621642 C54.9121613,62.8741781 53.7294502,62.9132735 52.738912,63.4493046 C51.1473626,64.3150561 49.4130964,65.0272522 47.5799178,65.5698777 C46.5013004,65.8882934 45.6402904,66.7031737 45.2639519,67.7634603 L43.105775,73.8317283 C40.9028519,74.0559382 39.1007601,74.0559382 36.897837,73.8317283 L34.7396601,67.7634603 C34.3628505,66.7055289 33.5018406,65.8878223 32.4236942,65.5698777 C30.5895735,65.0272522 28.8538944,64.3150561 27.2646999,63.4493046 C26.2741617,62.9090342 25.0890956,62.8746491 24.0735938,63.3621642 L18.2881536,66.1125032 C16.6909519,64.781846 15.2209235,63.3117641 13.8903147,61.7135624 L16.6414957,55.9269697 C17.124754,54.9100179 17.0913121,53.7239666 16.5534164,52.7348054 C15.6891095,51.1502635 14.9755263,49.4145212 14.4319785,47.5779787 C14.1126323,46.499322 13.2963686,45.6382808 12.2370626,45.2628706 L6.17137031,43.1055573 C6.0569144,42.0019361 6.001806,40.9849842 6.001806,40.0005334 C6.001806,39.0160825 6.0569144,38.0014858 6.17137031,36.8978646 L12.2384757,34.7386672 C13.2973106,34.363257 14.1126323,33.5022157 14.4319785,32.4235591 C14.9745843,30.5917269 15.6881674,28.8559846 16.5534164,27.2643772 C17.0913121,26.2775712 17.124754,25.0886938 16.6414957,24.0745681 L13.8903147,18.2879754 C15.2218656,16.6897737 16.691894,15.2173367 18.2881536,13.8890346 L24.0759488,16.6393735 C25.0890956,17.1273597 26.2788719,17.0882643 27.267055,16.5522332 C28.8553074,15.6864816 30.5895735,14.9742856 32.4236942,14.4316601 C33.5023116,14.1132444 34.3633215,13.2960089 34.7396601,12.2380775 L36.897837,6.16980947 C39.0800355,5.94324446 40.8854245,5.94324446 43.105775,6.16980947 L45.2639519,12.2380775 C45.6407615,13.2960089 46.5017714,14.1137154 47.5799178,14.4316601 C49.4140385,14.9742856 51.1497176,15.6864816 52.738912,16.5522332 C53.7294502,17.0925035 54.9121613,17.1268887 55.9300182,16.6393735 L61.7154584,13.8890346 C63.311718,15.2173367 64.7817464,16.6897737 66.1132973,18.2879754 L63.3621163,24.0745681 C62.878858,25.0891648 62.9122999,26.2775712 63.4501956,27.2643772 C64.3182706,28.8606949 65.0313828,30.594082 65.5716335,32.4212039 C65.8909796,33.5022157 66.7063014,34.363257 67.7665494,34.7386672 L73.8322417,36.8959805 C73.9466976,37.9996017 74.001806,39.0165536 74.001806,40.0010044 C74.001806,40.9854553 73.9466976,42.0019361 73.8322417,43.1055573 Z" id="path-1"></path>
                                </svg>
                            </div>
                            <!--header dropdwon menu-->
                            <div class="header-dropdown-menu" v-show='showTool'>
                                <a
                                    href="https://portal.dsedj.gov.mo/webdsejspace/internet/Inter_main_page.jsp?id=18518&"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <p>{{ lang($t("Terms and Conditions")) }}</p>
                                </a>
<!--                                <a href="#" @click.prevent="redirectTo('Disclaimer')">-->
<!--                                    <p>{{ lang($t("Disclaimer")) }}</p>-->
<!--                                </a>-->
                                <a href="#" @click.prevent="redirectTo('ContactUs')">
                                    <p>{{ lang($t("Contact Us")) }}</p>
                                </a>
                                <a
                                    v-show="companyLogoUrl !== '#'"
                                    :href="companyLogoUrl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <p>{{ lang($t("Editora Kai Yuen de Macau")) }}</p>
                                </a>
                            </div>
                            <!--end header dropdown menu-->

                        </div>

                        <div class="right-menu-btn" :tooltip="lang($t('My Download'))" flow="down"  @click="showMyDownload" v-show="showLoginBtn">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                                    <path d="M77.7777778,9.77777778 L71.5555556,2.22222222 C70.6666667,0.888888889 68.8888889,0 66.6666667,0 L13.3333333,0 C11.1111111,0 9.33333333,0.888888889 8,2.22222222 L2.22222222,9.77777778 C0.888888889,11.5555556 0,13.3333333 0,15.5555556 L0,71.1111111 C0,76 4,80 8.88888889,80 L71.1111111,80 C76,80 80,76 80,71.1111111 L80,15.5555556 C80,13.3333333 79.1111111,11.5555556 77.7777778,9.77777778 Z M40,64 L15,40 L31,40 L31,28 L49,28 L49,40 L65,40 L40,64 Z M8,10 L13.0793651,4 L66.9206349,4 L72,10 L8,10 Z"></path>
                                </svg>
                            </div>
                            <span class="status-tag" v-show="storeMyDownload.hasNewNotification">!</span>
                        </div>
                        <a href="/search" class="right-menu-btn"  :tooltip="lang($t('Search'))" flow="down"  v-show="showLoginBtn">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                                    <path d="M57.9644994,50.7081812 L80,72.8167282 L72.8288188,80 L50.7090618,57.9638637 C45.4473964,61.7619702 38.9850581,64 32,64 C14.326888,64 0,49.673112 0,32 C0,14.326888 14.326888,0 32,0 C49.673112,0 64,14.326888 64,32 C64,38.9846685 61.7622199,45.4466754 57.9644994,50.7081812 Z M32,54 C44.1502645,54 54,44.1502645 54,32 C54,19.8497355 44.1502645,10 32,10 C19.8497355,10 10,19.8497355 10,32 C10,44.1502645 19.8497355,54 32,54 Z"></path>
                                </svg>
                            </div>
                        </a>
                        <button
                            type="button"
                            class="activation-code-btn"
                            :tooltip="lang($t('Bind Activation Code'))"
                            flow="down"
                            v-show="showActivationCodeBtn"
                            @click="openActivationCodeBind"
                        >
                            <span>{{ lang($t('Bind Activation Code')) }}</span>
                        </button>
                    </div>
                </div>

            </header>
        </mq-layout>
        <mq-layout mq="narrow">
            <header class="mobile-header logged-in">
                <div class="header-logo" v-show="!is404">
                    <a href="/">
                        <img :src="mobile_logo">
                    </a>
                </div>

                <!-- mobile menu button-->
                <template v-if="showLoginBtn && showRightMenu">
                    <div class="mobile-header-btn left-corner"  :tooltip="lang($t('Menu'))" flow="down">
                        <a @click.prevent="openMobileMenu">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                                <path d="M7,11h66c2.762,0,5,2.239,5,5s-2.238,5-5,5H7c-2.761,0-5-2.239-5-5S4.239,11,7,11z M7,35h66c2.762,0,5,2.239,5,5c0,2.762-2.238,5-5,5H7c-2.761,0-5-2.238-5-5C2,37.239,4.239,35,7,35z M7,59h66c2.762,0,5,2.238,5,5s-2.238,5-5,5H7c-2.761,0-5-2.238-5-5S4.239,59,7,59z"></path>
                            </svg>
                        </a>
                    </div>
                </template>
                <template v-else>
                    <template v-show="showRightMenu">
                        <div class="mobile-header-btn left-corner" :tooltip="lang($t('Login'))" flow="down" @click="showLogin">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                                    <polygon fill="#FFFFFF" points="30,61 58,40 30,19 30,32 0,32 0,48 30,48"></polygon>
                                    <path fill="#FFFFFF" d="M72,0H18.001C13.688,0,10,3.661,10,8v12h8.001V8H72v32v32H18.001V60H10v12c0,4.339,3.688,8,8.001,8H72
		c4.354,0,8-3.661,8-8V40V8C80,3.661,76.354,0,72,0z"></path>
                                </svg>
                            </div>
                        </div>
                    </template>

                </template>

                <div
                    class="mobile-header-btn activation-code-corner"
                    :tooltip="lang($t('Bind Activation Code'))"
                    flow="down"
                    v-show="showActivationCodeBtn"
                    @click="openActivationCodeBind"
                >
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
                            <path fill="#FFFFFF" d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h2.172a2 2 0 0 0 1.414-.586l.9-.9a2 2 0 0 0 0-2.828l-1.172-1.172a2 2 0 0 0-2.828 0l-.9.9z"></path>
                            <circle cx="16" cy="8" r="6" fill="none" stroke="#FFFFFF" stroke-width="2"></circle>
                        </svg>
                    </div>
                </div>

                <div class="mobile-header-btn right-corner" :tooltip="lang($t('Search'))" flow="down" onclick="window.location.href='/search'" v-show="showLoginBtn && showRightMenu">
                    <a @click.prevent="">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                            <path d="M57.9644994,50.7081812 L80,72.8167282 L72.8288188,80 L50.7090618,57.9638637 C45.4473964,61.7619702 38.9850581,64 32,64 C14.326888,64 0,49.673112 0,32 C0,14.326888 14.326888,0 32,0 C49.673112,0 64,14.326888 64,32 C64,38.9846685 61.7622199,45.4466754 57.9644994,50.7081812 Z M32,54 C44.1502645,54 54,44.1502645 54,32 C54,19.8497355 44.1502645,10 32,10 C19.8497355,10 10,19.8497355 10,32 C10,44.1502645 19.8497355,54 32,54 Z"></path>
                        </svg>
                    </a>
                </div>

                <a :href="relation_url"
                   class="btn-language"
                   v-show="this.storeMainSite.relation !== null && !showLoginBtn"
                >
                    {{ relation_lang }}
                </a>

            </header>
        </mq-layout>
    </div>

</template>

<script>

    import Vue from 'vue';
    import router from '@js/routes';
    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';
    import EventBus from '@common/eventBus';
    import api from '@js/api';
    import axios from 'axios';

    export default {
        name: "Header",
        mixins:[common,storeMapper],
        data: function() {
            return {
                showTool: false,
                isShowMobileMenu:false,
                getImageApi: getImageApi,
                showMemberTool: false,
                showLoginBtn: false,
                display_name: "",
                member_avatar: "",
                showRightMenu: true
            }
        },
        created() {

            this.isLoggedIn();
        },
        methods: {
            getHkepLogo()
            {
                return window.location.origin +'/img/logo-hkep.png';
            },
            hideRightPanel()
            {
                this.showRightMenu = false;

            },
            showSetting() {
                if (this.showTool) {
                    this.showTool = false;
                } else {
                    this.showTool = true;
                    this.showMemberTool = false;
                }
            },
            showMember() {
                if (this.showMemberTool) {
                    this.showMemberTool = false;
                } else {
                    this.showMemberTool = true;
                    this.showTool = false;
                }
            },
            showMyDownload() {
                if (this.$route.name === "Home") {
                    Promise.all(
                        [
                            api.getDownloadData()
                        ]
                            .map(p => p.catch(() => undefined)))
                        .then(axios.spread((responseDownloadData) => {

                            if (responseDownloadData) {
                                this.$store.commit("my_download_store/updateData", responseDownloadData.data);
                            }

                            EventBus.$emit("showMyDownload", "top");
                            this.$store.commit("my_download_store/offNotification");
                        }));
                } else {
                    EventBus.$emit("add_to_inventory", "top");

                }


            },
            openMobileMenu() {
                EventBus.$emit("openMobileMenu");
            },
            redirectTo(uri)
            {
                router.push({
                    name: uri
                });
            },
            showLogin()
            {
                EventBus.$emit("showLogin");
            },
            openActivationCodeBind() {
                if (this.activationCodeBindUrl) {
                    let url = this.activationCodeBindUrl;
                    const token = window.access_token;
                    if (token && !url.includes('access_token=')) {
                        // If the URL already has query string, append with '&', otherwise '?'
                        const separator = url.includes('?') ? '&' : '?';
                        url = `${url}${separator}access_token=${encodeURIComponent(token)}`;
                    }
                    window.open(url, '_blank', 'noopener');
                }
            },
            isLoggedIn()
            {
                if (this.checkIsLoggedIn()) {
                    this.showLoginBtn = true;
                    this.display_name = display_name;
                    this.member_avatar = member_avatar;
                } else {
                    this.showLoginBtn = false;
                    this.display_name = "";
                    this.member_avatar = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D";
                }
            },
            logout()
            {
                EventBus.$emit("showGlobalLoading");
                let self = this;

                api.userLogout().then(resp=> {
                    var url = window.location.protocol+"//"+window.location.host;

                    window.location.href = url;
                    EventBus.$emit("hideGlobalLoading");

                }).catch(function (resp) {
                    self.showLoginBtn = true;
                    EventBus.$emit("hideGlobalLoading");

                });
            }
        },
        computed: {
            is404() {
                return this.$router.currentRoute.name ===  "NotFound";
            },
            logo() {
                if (this.storeMainSite.logo !== null) {
                    return this.getImageApi+this.storeMainSite.logo;
                }

                return "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D";
            },
            mobile_logo() {

                if (this.storeMainSite.mobile_logo !== null) {
                    return this.getImageApi+this.storeMainSite.mobile_logo;
                }

                if (this.storeMainSite.logo !== null) {
                    return this.getImageApi+this.storeMainSite.logo;
                }

                return "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D";
            },
            relation_url()
            {
                return this["mainSite/getRelationURL"];
            },
            relation_lang()
            {
                return this['mainSite/getRelatedLangStr'];
            },
            activationCodeBindUrl() {
                if (typeof activation_code_bind_url === 'undefined' || !activation_code_bind_url) {
                    return '';
                }

                return activation_code_bind_url.trim();
            },
            showActivationCodeBtn() {
                return this.showLoginBtn && this.showRightMenu && this.activationCodeBindUrl !== '';
            }
        },
        watch:{
            $route (to, from){
                this.showTool = false;
                this.showMemberTool = false;
                this.isLoggedIn();
            }
        },
        mounted() {

            this.isLoggedIn();

        }
    }

</script>

<!-- Some styles are shared to nswmenu mobile, so not set scoped -->
<style lang="scss">

    @import "~@sass/_variables.scss";
    @import "~@sass/_mixins.scss";

    /*header*/
    header {
        @extend %bg-primary;
        width: 100%;
        height: 3.5rem;

    }

    .header-logo {
        float: left;
        padding-left:1.5rem;
        height: 3.5rem;
        width: 50%;
    }
    .header-logo img {
        max-height: 100%;
    }

    .right-menu>* {
        float: right;
        color: #fff;
    }

    .right-menu > div , .right-menu> a {
        &:hover {
            @extend %hover-dimmest;
        }
    }

    .right-menu {
        float: right;
        padding: 0.75rem 1.5rem;
        display: inline-block;
        width: 50%;
    }

    .right-menu .btn-language, .right-menu .btn-login {
        margin: 0.1875rem 1.45rem 0 0;
        -webkit-transition: all 0.2s ease-in-out;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }

    .right-menu .btn-login {
        margin-right: 0.5rem;
    }

    .right-menu .btn-login:hover {
        background-color: #efce5f;
        border-color: #efce5f;
    }

    .activation-code-btn {
        border: 1px solid rgba(255, 255, 255, 0.75);
        border-radius: 7px;
        background: #fff;
        color: #202632;
        min-height: 2rem;
        padding: 0.25rem 0.75rem;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        float: right;
        margin: 0 0.375rem;
        font-size: 0.875rem;
        line-height: 1;
        -webkit-transition: all 0.2s ease-in-out;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }

    .activation-code-btn svg {
        width: 1rem;
        height: 1rem;
        color: #202632;
        flex-shrink: 0;
    }

    .activation-code-btn:hover {
        background-color: #efce5f;
        border-color: #efce5f;
    }

    .right-menu-btn,
    .setting-menu-btn {
        width: 2rem;
        height: 2rem;
        margin: 0 0.375rem;
        position: relative;
        cursor: pointer;
        -webkit-radius: 6px;
        -moz-border-radiust: 6px;
        border-radius: 6px;
        -webkit-transition: all 0.2s ease-in-out;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }

    .right-menu-btn div {
        width: 1.25rem;
        height: 1.25rem;
    }

    .right-menu-btn div,
    .setting-menu-btn div {
        margin: 0.375rem;
    }

    .right-menu-btn div svg,
    .setting-menu-btn div svg {
        fill: #fff;
    }

    .right-menu-btn .status-tag,
    .setting-menu-btn .status-tag
    {
        position: absolute;
    }

    .user-btn {
        margin: 0 1.5rem 0 0.75rem;
        width: 2rem;
        height: 2rem;
        position: relative;
        cursor: pointer;
        -webkit-radius: 50%;
        -moz-border-radiust: 50%;
        border-radius: 50%;
        -webkit-transition: all 0.2s ease-in-out;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }

    .profile-pic {
        position: absolute;
        left: 0.125rem;
        top: 0.125rem;
        background-size: 100%;
        width: 1.75rem;
        height: 1.75rem;
        float: left;
        -webkit-radius: 50%;
        -moz-border-radiust: 50%;
        border-radius: 50%;
        overflow:hidden;
    }

    .profile-pic img {
        width:100%;
        height:100%;
        display:block;
    }

    /*header (slim)*/
    header#slim {
        background-color: #007ac6;
        position: fixed;
        top: -3.5rem;
        width: 100%;
        display: block;
        z-index: 10;
        -webkit-transition: top 0.5s ease-in-out;
        -moz-transition: top 0.5s ease-in-out;
        -o-transition: top 0.5s ease-in-out;
        transition: top 0.5s ease-in-out;
    }

    header#slim .row-path {
        margin: 0;
        float: left;
        padding: 1rem 1.5rem 1rem 1.5rem;
        height: 1.25rem;
        overflow: visible;
    }

    header#slim ul.path li {
        color: #fff;
    }

    header#slim ul.path .path-home {
        background: url(/image/home-slim.svg) no-repeat scroll left top;
        background-size: 100%;
    }

    /*mobile header*/
    .mobile-header {
        display: none;
    }

    .mobile-header-btn {
        @extend %bg-primary;
        width: 2.5rem;
        height: 2.5rem;
        margin: .5rem;
        position: relative;
        cursor: pointer;
        -webkit-radius: 6px;
        -moz-border-radiust: 6px;
        border-radius: 6px;
        -webkit-transition: all 0.2s ease-in-out;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
        &:hover {
            @extend %hover-dimmest;
        }
    }

    .mobile-header-btn:hover {
        background-color: #005b99;
    }

    .mobile-header-btn a {
        width: 1.5rem;
        height: 1.5rem;
        display: inline-block;
        padding: .5rem;
        box-sizing: content-box;
    }

    .mobile-header .btn-language {
        color: #fff;
        position: absolute;
        right: .75rem;
        height: 1.75rem;
        padding: 0rem .5rem;
        line-height: 1.625rem;
        border: 2px solid #fff;
        margin: 0;
        top: .875rem;
        text-align: center;
        font-size: 1rem;
        -webkit-radius: 6px;
        -moz-border-radiust: 6px;
        border-radius: 6px;
        -webkit-transition: all 0.2s ease-in-out;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }

    .mobile-header-btn div {
        width: 1.5rem;
        height: 1.5rem;
        margin: 0.5rem;
    }

    .mobile-header-btn div a {
        width:100%;
        height:100%;
        display:inline-block;
    }

    .mobile-header-btn svg {
        fill: #fff;
    }

    .mobile-header-btn .status-tag {
        position: absolute;
    }

    .mobile-header-btn.left-corner {
        position: absolute;
        left: 0;
        top: 0;
    }

    .mobile-header-btn.right-corner {
        position: absolute;
        right: 0;
        top: 0;
    }

    .mobile-header-btn.activation-code-corner {
        position: absolute;
        right: 3.5rem;
        top: 0;
    }

    .mobile-header-btn.activation-code-corner svg {
        width: 1.5rem;
        height: 1.5rem;
        display: block;
    }

    .mobile-header .header-logo {
        width: 100%;
        padding: 0;
        text-align: center;
    }

    .menu-btn {
        @extned %all-in-one
    }

    /*header dropdown menu*/
    .header-dropdown-menu {
        @extend %border-primary;

        border:1px solid $allow;
        position: absolute;
        background-color: #fff;
        top: 2.5rem;
        right: -0.85rem;
        z-index: 25;
        padding: 0.5rem 0;
        width: 15rem;
        display: block;
        -webkit-radius: 6px;
        -moz-border-radiust: 6px;
        border-radius: 6px;
        -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
        -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
    }

    .header-dropdown-menu:after {
        content: '';
        width: 0.75rem;
        height: 0.75rem;
        display: block;
        background-color: #fff;
        position: absolute;
        right: 1.125rem;
        top: -0.375rem;
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
    }

    .right-menu .header-dropdown-menu a {
        width: 100%;
        display: block;
        padding: 0.75rem 1.25rem;
        background-color: #fff;
        overflow: hidden;
        margin-bottom: 0.125rem;
        -webkit-transition: all 0.2s ease-in-out;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }

    .right-menu .header-dropdown-menu a:hover {
        @extend %bg-secondary;
        width: 100%;
        display: block;
        padding: 0.75rem 1.25rem;
        -webkit-transition: all 0.2s ease-in-out;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }

    .right-menu .header-dropdown-menu a:hover p {
        @extend  %text-primary;
    }

    .right-menu .header-dropdown-menu a:last-child {
        margin-bottom: 0;
    }

    .right-menu .header-dropdown-menu p {
        color: #3d3d3d;
        float: left;
    }

    .right-menu .header-dropdown-menu span {
        @extend  %text-secondary;
        float: right;
    }


    @include narrow {
        header {
            display: none;
        }

        .mobile-header {
            display: block;
            position: fixed;
            z-index: 90;
            top:0;
        }

        .header-logo {
            max-width: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/NswHeader.vue